import { IFormField } from './form-field.model';

export interface IEoFormTableConfig {
  id?: string;
  groupId?: string;
  formId?: string;
  formFields?: IFormField[];
  tableData?: any[];

  label?: string;
  styleClass?: string;
  createButtonLabel?: string;
  createButtonStyleClass?: string;
  createButtonIcon?: string;
  formHeader?: string;
  submitButtonLabel?: string;
  submitButtonStyleClass?: string;
  submitButtonIcon?: string;
  fetchApiUrl?: string;
  submitApiUrl?: string;
  deleteApiUrl?: string;
  submitLoading?: boolean | ((formData: any) => boolean);
  deleteLoading?: boolean | ((formData: any) => boolean);
  minEntries?: number;
  maxEntries?: number;
  requiredNumberOfEntries?: number;
  onSubmit?: (formData: any) => void;
  onDelete?: (selectedItem: any) => void;
}

export class EoFormTableConfig implements IEoFormTableConfig {
  id?: string;
  formId?: string;
  groupId?: string;
  formFields?: IFormField[];
  tableData?: any[];
  styleClass?: string;
  label?: string;
  formHeader?: string;
  createButtonLabel?: string;
  createButtonStyleClass?: string;
  createButtonIcon?: string;
  submitButtonLabel?: string;
  submitButtonStyleClass?: string;
  submitButtonIcon?: string;
  fetchApiUrl?: string;
  submitApiUrl?: string;
  deleteApiUrl?: string;
  submitLoading?: boolean | ((formData: any) => boolean);
  deleteLoading?: boolean | ((formData: any) => boolean);
  minEntries?: number;
  maxEntries?: number;
  requiredNumberOfEntries?: number;
  onSubmit?: (formData: any) => void;
  onDelete?: (selectedItem: any) => void;

  constructor();
  constructor(obj: IEoFormTableConfig);
  constructor(obj?: IEoFormTableConfig) {
    this.id = obj?.id ?? '';
    this.label = obj?.label ?? '';
    this.groupId = obj?.groupId ?? '';
    this.formId = obj?.formId ?? '';
    this.formFields = obj?.formFields;
    this.tableData = obj?.tableData;
    this.formHeader = obj?.formHeader;
    this.createButtonLabel = obj?.createButtonLabel;
    this.createButtonStyleClass = obj?.createButtonStyleClass;
    this.createButtonIcon = obj?.createButtonIcon;
    this.submitButtonLabel = obj?.submitButtonLabel;
    this.submitButtonStyleClass = obj?.submitButtonStyleClass;
    this.submitButtonIcon = obj?.submitButtonIcon;
    this.submitApiUrl = obj?.submitApiUrl ?? '';
    this.fetchApiUrl = obj?.fetchApiUrl ?? '';
    this.deleteApiUrl = obj?.deleteApiUrl ?? '';
    this.submitLoading = obj?.submitLoading ?? false;
    this.deleteLoading = obj?.deleteLoading ?? false;
    this.minEntries = obj?.minEntries;
    this.maxEntries = obj?.maxEntries;
    this.requiredNumberOfEntries = obj?.requiredNumberOfEntries;
    this.onSubmit = obj?.onSubmit;
    this.onDelete = obj?.onDelete;
  }
}
